import apiClient from "@/libs/axios";
import store from "@/state/store";
import router from "@/router";

export const state = {
    basic: null,
    full: null,
    roles: [],
}

export const actions = {
    async basic({commit}) {
        // commit('loadingStart', null, {root: true});
        return await apiClient
            .get(`api/v1/profile`)
            .then((response) => {
                if (response.status === 200) {
                    console.log(response.data.result)
                    commit('setBasicData', response.data.result);

                    // commit('loadingFinish', null, {root: true});
                }
                return response.data.data;
            })
            .catch((error) => {
                // commit('loadingFinish', null, {root: true});
                throw error;
            });

    },


    async full({commit}) {
        commit('loadingStart', null, {root: true});
        return await apiClient
            .get(`api/v1/profile/full`)
            .then((response) => {
                if (response.status === 200) {
                    commit('setFullData', response.data.data);

                    commit('loadingFinish', null, {root: true});
                }
            })
            .catch((error) => {
                commit('loadingFinish', null, {root: true});
                throw error;
            });
    },

    async update({commit}, data) {
        commit('loadingStart', null, {root: true});
        return await apiClient
            .post(`api/v1/profile/update`, data)
            .then((response) => {
                if (response.status === 200) {
                    commit('loadingFinish', null, {root: true});
                    commit('successMessage', 'contacts_changed');
                }
            })
            .catch((error) => {
                commit('loadingFinish', null, {root: true});
                throw error;
            });
    },

    async setupAccount({commit, dispatch}, data) {
        commit('loadingStart', null, {root: true});
        console.log(store)
        data = {id: store.state.profile.profile.basic.id, ...data}
        console.log(data);
        return await apiClient
            .post(`api/v1/vendors/setup-account`, data)
            .then((response) => {
                if (response.status === 200) {
                    // commit('loadingFinish', null, {root: true});
                    // commit('successMessage', 'contacts_changed');
                    commit('setFullData', response.data.result);
                    dispatch('basic');
                    console.log(response)
                    if (response.data.result.has_data) {
                        router.push({name: 'dashboard'})
                    }
                }
            })
            .catch((error) => {
                // commit('loadingFinish', null, {root: true});
                throw error;
            });
    },
}

export const getters = {
    getBasic(state) {
        return state.basic;
    },
    getRoles(state) {
        return state.roles;
    },
    getFull(state) {
        return state.full;
    },
}

export const mutations = {
    setBasicData: (state, data) => {
        state.basic = data;
        state.roles = data.roles;
    },
    setFullData: (state, data) => {
        state.full = data;
    },
}